import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InicioComponent } from './inicio.component';
import { InicioRoutingModule } from './inicio-routing.module';
import { InicioService } from './inicio.service';
import { DxChartModule, DxDateBoxModule } from 'devextreme-angular';
import { DxiSeriesModule } from 'devextreme-angular/ui/nested';
import { MetricasResumenComponent } from './components/metricas-resumen/metricas-resumen.component';
import { VentasDiariasChartComponent } from './components/ventas-diarias-chart/ventas-diarias-chart.component';
import { VentaSemanalComponent } from './components/venta-semanal/venta-semanal.component';
import { ComparativaDiasComponent } from './components/comparativa-dias/comparativa-dias.component';
import { HatchDefsComponent } from './components/hatch-defs/hatch-defs.component';
import { SaldoCobrarComponent } from './components/saldo-cobrar/saldo-cobrar.component';

@NgModule({
  declarations: [
    InicioComponent,
    MetricasResumenComponent,
    VentasDiariasChartComponent,
    VentaSemanalComponent,
    ComparativaDiasComponent,
    HatchDefsComponent,
    SaldoCobrarComponent
  ],
  imports: [
    CommonModule,
    InicioRoutingModule,
    DxChartModule,
    DxDateBoxModule,
    DxiSeriesModule
  ],
  providers: [InicioService]
})
export class InicioModule { }
